import { UTXOsFetchError } from '../../../errors/UTXOsFetchError';
import { MEMPOOL_API_URL } from '../../constants';
import type { UTXO } from '../../WaasBitcoinWalletProvider.types';

/**
 * Gets UTXOs for a Bitcoin address from mempool.space API
 *
 * @param address - The Bitcoin address to get UTXOs for
 * @returns Array of UTXOs
 * @throws UTXOsFetchError if fetching UTXOs fails
 */
export const getUTXOs = async (address: string): Promise<UTXO[]> => {
  const response = await fetch(`${MEMPOOL_API_URL}/address/${address}/utxo`);

  if (!response.ok) {
    throw new UTXOsFetchError({ address, response });
  }

  return response.json();
};
